import axios, { AxiosRequestConfig } from 'axios'
import {
  ValidateAddressRequest,
  ValidateAddressResponse,
} from 'src/models/addressValidation.models'

export const validateAddress = async (
  body: ValidateAddressRequest,
  config: AxiosRequestConfig,
): Promise<ValidateAddressResponse> => {
  const response = await axios.post<ValidateAddressResponse>(
    '/addresses/validate',
    body,
    config,
  )
  return response.data
}
